export default __webpack_public_path__ + "static/media/icon1.4a941b2a.svg";